import React from 'react'
import Reporte from '../../../Modulos/Reporteservicio'

const ModalReporteServicio2 = ({ infocontrato, ultPunto, contractR, mostrarReporte, onCloseModalReporteServicio}) => {
    return (
        <div className="modal-dialog modal-lg">
            <form className="modal-content">
                <div className="modal-header">
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={onCloseModalReporteServicio}
                    ></button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {mostrarReporte ? (
                            <Reporte
                                mostrarReporte={mostrarReporte}
                                contrato={infocontrato}
                                ultPunto={ultPunto}
                                contractR={contractR}
                            />
                        ) : null}
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ModalReporteServicio2
